import { render, staticRenderFns } from "./UserMoreInformation.vue?vue&type=template&id=6c64e0ca&scoped=true&"
import script from "./UserMoreInformation.vue?vue&type=script&lang=js&"
export * from "./UserMoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./UserMoreInformation.vue?vue&type=style&index=0&id=6c64e0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64e0ca",
  null
  
)

export default component.exports